const GraphReducer = (state, action) => {
    switch (action.type) {
        case 'set_process_compare_filters1':
            return {
                ...state,
                processCompare: { ...state.processCompare.layer2_filters , layer1_filters: action.value},
            }
        case 'set_process_compare_filters2':
            return {
                ...state,
                processCompare: { ...state.processCompare.layer1_filters , layer2_filters: action.value},
            }
        case 'set_process_compare_advanced_activity_filters1':
            return {
                ...state,
                processCompareAdvancedActivityFilters1: action.value,
            }
            case 'set_process_compare_advanced_activity_filters2':
            return {
                ...state,
                processCompareAdvancedActivityFilters2: action.value,
            }
            case 'set_process_compare_filters':
            return {
                ...state,
                processCompare: action.value,
            }
        case 'set_process_map_active_filters':
            return {
                ...state,
                processMapActiveFilters: action.value,
            }
            case 'set_process_map_advanced_activity_filters':
            return {
                ...state,
                processMapAdvancedActivityFilters: action.value,
            }
        case 'process_map_set_variant':
            return {
                ...state,
                processMapVariants: action.value,
            }
        case 'process_compare_set_filter' :
            return {
                ...state,
                processCompareFilters: action.value,
            }
        case 'set_process_compare_active_filters' :
            return {
                ...state,
                processCompareActiveFilters: action.value,
            }
        case 'process_compare_set_variant' :
            return {
                ...state,
                processCompareVariants: action.value,
            }
        case 'set_data_pool_id_inProgress' :
            return {
                ...state,
                dataPoolIdInProgress: action.value,
            }
        case 'set_active_variants_process_compare' :
            return {
                ...state,
                activeVariantsProcessCompare: action.value,
            }
        case 'set_active_variants_process_map' :
            return {
                ...state,
                activeVariantsProcessMap: action.value,
            }
        case 'set_process_explorer_view' :
            return {
                ...state,
                processExplorerView: action.value,
            }
            case 'set_process_explorer_advanced_activity_filters' :
            return {
                ...state,
                processExplorerAdvancedActivityFilters: action.value,
            }
        case 'set_process_explorer_metrics' :
            return {
                ...state,
                processExplorerMetrics: action.value,
            }
        case 'set_process_explorer_filters' :
            return {
                ...state,
                processExplorerFilters: action.value,
            }
        case 'set_process_explorer_active_filters' :
            return {
                ...state,
                processExplorerActiveFilters: action.value,
            }
        case 'set_process_explorer_flow' :
            return {
                ...state,
                processExplorerFlow: action.value,
            }
        case 'set_process_explorer_variants' :
            console.log(state,action.value)
            return {
                ...state,
                processExplorerVariants: action.value,
            }
        case 'set_process_explorer_active_variants' :
            return {
                ...state,
                processExplorerActiveVariants: action.value,
            }
        case 'set_generate_bpmn_Filters' :
            return {
                ...state,
                generateBpmnFilters: action.value,
            }
        case 'set_generate_bpmn_Flow' :
            return {
                ...state,
                generateBpmnFlow: action.value,
            }
        case 'set_generate_bpmn_variants' :
            return {
                ...state,
                generateBpmnVariants: action.value,
            }
        case 'set_generate_bpmn_active_variants' :
            return {
                ...state,
                generateBpmnActiveVariants: action.value,
            }
        case 'set_generate_bpmn_metrics' :
            return {
                ...state,
                generateBpmnMetrics: action.value,
            }
        case 'set_data_analysis_Filters' :
            return {
                ...state,
                dataAnalysisFilters: action.value,
            }
            case 'set_data_analysis_advanced_activity_filters' :
            return {
                ...state,
                dataAnalysisAdvancedActivityFilters: action.value,
            }
        case 'set_data_analysis_Flow' :
            return {
                ...state,
                dataAnalysisFlow: action.value,
            }
        case 'set_data_analysis_variants' :
            return {
                ...state,
                dataAnalysisVariants: action.value,
            }
        case 'set_data_analysis_active_variants' :
            return {
                ...state,
                dataAnalysisActiveVariants: action.value,
            }
        case 'set_conformance_checking_save_obj' :
            return {
                ...state,
                conformanceCheckingSaveObj: action.value
            }
            case 'set_conformance_checking_advanced_activity_filters' :
            return {
                ...state,
                conformanceCheckingAdvancedActivityFilters: action.value
            }
        case 'set_conformance_checking_filters' :
            return {
                ...state,
                conformanceCheckingFilters: action.value,
            }
        case 'set_conformance_checking_flow' :
            return {
                ...state,
                conformanceCheckingFlow: action.value,
            }
        case 'set_conformance_checking_variants' :
            return {
                ...state,
                conformanceCheckingVariants: action.value,
            }
        case 'set_conformance_checking_active_variants' :
            return {
                ...state,
                conformanceCheckingActiveVariants: action.value,
            }
        case 'set_conformance_checking_metrics' :
            return {
                ...state,
                conformanceCheckingMetrics: action.value,
            }
        case 'set_bpmn_id' :
            return {
                ...state,
                bpmnId: action.value,
            }
        case 'set_process_compare_version' :
            return {
                ...state,
                processCompareSaveVersion: action.value,
            }
            case 'set_item_active_index' :
            return {
                ...state,
                itemActiveIndex: action.value,
            }
        default:
            break
    }
}
export default GraphReducer